/* eslint-disable no-unsafe-optional-chaining */

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import Triad from '../../../assets/Vector_Triad.png';
import { ROLES } from '../../../constants';
import {
    selectCurrentEmpid,
    selectCurrentUser,
    selectCurrentUserManagerLevel,
    selectIsPseudoSupervisor,
} from '../../../pages/login/authSlice';
import { getRole } from '../../../utils/roleUtils';
import { CoachingEntityTypes, CoachingTabs } from '../../../utils/typeConstants';
import { ManagerSelectionView } from '../coachingSummary/ManagerSelectionView';
import NewConversationLog from '../conversationLogs/newConversationLog/NewConversationLog';
import ReadConversationLog from '../conversationLogs/readConversationLog/ReadConversationLog';
import { EmployeeSearchPopUp } from '../employeeSearchPopUp/EmployeeSearchPopUp';
import { RevgenFilter } from '../revGen/RevgenFilters';
import { TriadExpandedGrid } from './TriadExpandedGrid';
import { TriadHome } from './TriadHome';
import CoachingGuidance from './coachingGuidance/CoachingGuidance';
import { useGetTriadInfoQuery } from './triad.slice';
import { SearchedEmployeType } from '../revGen/type';
import { saveSCfilDate } from '../../../utils/dateStorage';

interface TriadSummaryProps {
    inputMonth: number;
    inputYear: number;
    date: Date;
    setMonth: (month: number) => void;
    setYear: (year: number) => void;
    setDate: (date: Date) => void;
    userParentClient: any[];
    teamOptionId?: string | undefined;
    entityId?: string | undefined;
    entityDate?: string | undefined;
}

export const TriadSummary = (props: TriadSummaryProps) => {
    const [coachingSummaryList, setCoachingSummaryList] = useState<any>([]);
    const [selectedTeam, setSelectedTeam] = useState<string>();
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const loggedEmpUser = useSelector(selectCurrentUser);
    const [displayModal, setDisplayModal] = useState(false);

    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);
    const isPseudoSupervisor = useSelector(selectIsPseudoSupervisor);
    const [expandedRows, setExpandedRows] = useState<any>();
    const [showTriadModal, setShowTriadModal] = useState<boolean>(false);
    const [showTriadRecordModal, setShowTriadRecordModal] = useState<boolean>(false);
    const [selectedEmployee, setSelectedEmploye] = useState<any>('');
    const [selectTeamList, setSelectTeamList] = useState<string[]>();
    const [visible, setVisible] = useState<boolean>(false);
    const [hirearchy, setHirearchy] = useState<any>({});
    // const [triadVersionId, setTriadVersionId] = useState<number>();
    const [searchedEmployee, setSearchedEmployee] = useState<any>({});
    const [selectedDate, setSelectedDate] = useState<any>();
    const [selectedManager, setSelectedManager] = useState('');
    const [isCoachingGuidanceVisible, setIsCoachingGuidanceVisible] = useState(false);
    const [showConversationModal, setShowConversationModal] = useState<boolean>(false);
    const [recieverId, setRecieverId] = useState<string>('');
    const [receiverName, setReceiverName] = useState<string>('');
    const [viewState, setViewState] = useState<string>('read');
    const [triadReceipient, setTriadReceipient] = useState('');
    const [triadYear, setTriadYear] = useState(0);
    const [triadMonth, setTriadMonth] = useState(0);
    const [isConfiguredNewTriad, setIsConfiguredNewTriad] = useState<boolean>(false);
    // const [childGridData, setChildGridData] = useState<any>();

    const { data: triadInfo } = useGetTriadInfoQuery(
        {
            loggedempNumber: loggedEmpNum,
            employeeNumber: selectedTeam === 'search' ? selectedEmployee : loggedEmpNum,
            year: props?.inputYear,
            month: props?.inputMonth,
            teamOption: selectedTeam === 'myActivity' ? 'mytriads' : 'myteamtriads',
            role: getRole(userManagerLevel, isPseudoSupervisor),
        },
        {
            skip:
                !loggedEmpNum ||
                !props?.inputYear ||
                !props?.inputMonth ||
                !selectedTeam ||
                (selectedTeam === 'search' && !selectedEmployee),
        }
    );

    useEffect(() => {
        setSelectedEmploye(searchedEmployee?.employee_number);
    }, [searchedEmployee]);
    
    useEffect(() => {
        if (selectedManager) {
            setSelectedTeam('search');
            setSelectedEmploye(selectedManager);
        }
        if (selectedDate) {
            props?.setDate(selectedDate);
            props?.setMonth(selectedDate.getMonth() + 1);
            props?.setYear(selectedDate.getFullYear());
        }
    }, [selectedDate, selectedManager]);
    
    useEffect(() => {
        setSelectedEmploye(loggedEmpNum);
    }, []);

    useEffect(() => {
        if (triadInfo?.data?.length > 0) {
            if (selectedTeam === 'myTeamActivity' && ROLES.Supervisor2AndAbove.includes(userManagerLevel)) {
                const filterOutOwnRec = triadInfo?.data?.filter((record: any) => {
                    return (
                        record.employee_number !== loggedEmpNum &&
                        !ROLES.Manager.includes(record.manager_level)
                    );
                });
                setCoachingSummaryList(filterOutOwnRec);
            } else {
                setCoachingSummaryList(triadInfo?.data);
            }
            setExpandedRows([]);
        }
    }, [triadInfo]);
    
    useEffect(() => {
        if (props?.teamOptionId && props?.entityId && props?.entityDate) {
            const triadDetails = props?.entityId.split('-');
            const recipient = triadDetails[0];
            if (triadDetails.length === 3) {
                setSelectedTeam('myteamtriads');
                // setTriadReceipient(triadDetails[0]);
                setTriadReceipient(recipient);
                setTriadYear(Number(triadDetails[1]));
                setTriadMonth(Number(triadDetails[2]));
                //setTriadId(Number(triadDetails[3]));
            }
            if (triadInfo?.data?.length > 0) {
                //if (selectedTeam === 'myTeamActivity' && ROLES.Supervisor2AndAbove.includes(userManagerLevel)) {
                const filterOutOwnRec = triadInfo?.data?.filter((record: any) => {
                    return (
                        // record.employee_number === triadReceipient
                        record.employee_number === recipient
                    );
                });
                if (filterOutOwnRec?.length > 0) {
                    const {
                        manager_level: managerLevel,
                        supervisor_name: supervisorName,
                        employee_name: employeeName,
                        employee_number: employeeNumber,
                        supervisor_number: supervisorNumber,
                    } = filterOutOwnRec[0];
                    rowExpansionTemplate(filterOutOwnRec[0]);
                    // Handle Supervisor Role
                    if (ROLES.Supervisor.includes(managerLevel)) {
                        setHirearchy({
                            manager: supervisorName,
                            teamLead: employeeName,
                            teamLeadId: employeeNumber,
                            associate: null,
                            associateId: null,
                        });
                    }

                    // Handle Agent Role
                    if (ROLES.Agents.includes(managerLevel)) {
                        setHirearchy({
                            teamLead: supervisorName,
                            teamLeadId: supervisorNumber,
                            associate: employeeName,
                            associateId: employeeNumber,
                        });
                    }
                    setDisplayModal(true);
                    setShowTriadRecordModal(true);
                    handleGridButtonClick('triads', 'child', filterOutOwnRec, 'edit');
                }
                //}
                setExpandedRows([]);
            }


        }
    }, [props?.teamOptionId, props?.entityId, props?.entityDate, triadInfo]);

    const triadHeaderTeplate = () => {
        return (
            <div className="employee-header-triad">
                <img src={Triad} alt="triad" />
                <span>Coaching Observations</span>
            </div>
        );
    };

    const headerTemplate = (header: string, colorcode: string) => {
        return (
            <div style={{ textAlign: 'center' }}>
                <div
                    className={'headerTemplate'}
                    style={{
                        background: colorcode,
                        borderRadius: '5px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '0px 10px',
                        // marginLeft: '22px',
                    }}
                >
                    <p style={{ margin: '0px' }}> {header}</p>
                </div>
            </div>
        );
    };

    const handleGridButtonClick = (columnName: string, grid: string, rowData?: any, mode?: string) => {
        if ((props?.inputMonth !== new Date().getMonth() + 1 || props?.inputYear !== new Date().getFullYear()) && mode === 'new') {
            toast.warning('Coaching Observations for the previous month can no longer be created once the new month begins.');
            return;
        }
        if ((props?.inputMonth !== new Date().getMonth() + 1 || props?.inputYear !== new Date().getFullYear()) && mode === 'edit') {
            toast.warning('Coaching Observations for the previous month can no longer be edited once the new month begins.');
        }
        const {
            manager_level: managerLevel,
            supervisor_name: supervisorName,
            employee_name: employeeName,
            employee_number: employeeNumber,
            supervisor_number: supervisorNumber,
            direct_reportees_count: directReporteesCount,
            tl_assoc_created_count: tlAssocCreatedCount,
            total_created_count: totalCreatedCount,
            total_triads_completed: totalTriadsCompleted,
            // triad_version_id: triadVersionId,
            isConfigured,
        } = rowData;

        // const triadVersionId = isConfigured ? 2 : 1;

        // Handle Supervisor Role
        if (ROLES.Supervisor.includes(managerLevel)) {
            setHirearchy({
                manager: supervisorName,
                teamLead: employeeName,
                teamLeadId: employeeNumber,
                associate: null,
                associateId: null,
            });
        }

        // Handle Agent Role
        if (ROLES.Agents.includes(managerLevel)) {
            setHirearchy({
                teamLead: supervisorName,
                teamLeadId: supervisorNumber,
                associate: employeeName,
                associateId: employeeNumber,
            });
        }

        // Handle Non-Agent Employees without Direct Reports in Parent Grid
        if (grid === 'parent' && !ROLES.Agents.includes(managerLevel) && directReporteesCount === 0) {
            toast.warning(
                'This employee does not have direct reportees, so a Coaching Observation cannot be created.'
            );
            setHirearchy({});
            return;
        }

        if (
            grid === 'parent' &&
            ROLES.Agents.includes(managerLevel) &&
            supervisorNumber === loggedEmpNum &&
            totalCreatedCount === 0
        ) {
            toast.warning('Author and Supervisor are same, so a Coaching Observation cannot be created.');
            setHirearchy({});
            return;
        }

        // Handle Non-Agent Employees with Direct Reports in Child Grid
        if (grid === 'child' && !ROLES.Agents.includes(managerLevel) && directReporteesCount > 0) {
            toast.warning('This employee is not an associate, so a Coaching Observation cannot be created.');
            setHirearchy({});
            return;
        }

        // Handle Triad Column Click
        if (columnName === 'triads') {
            const canCreateTriad =
                ROLES.Supervisor2AndManagers.includes(userManagerLevel) ||
                ROLES.DirectorOrAbove.includes(userManagerLevel) ||
                (ROLES.Supervisor.includes(userManagerLevel) &&
                    (tlAssocCreatedCount || totalTriadsCompleted));

            if (canCreateTriad) {
                // setTriadVersionId(triadVersionId);
                setIsConfiguredNewTriad(isConfigured);
                setShowTriadModal(true);
                setDisplayModal(true);
                setShowConversationModal(false);
            } else {
                toast.warning('Only Managers can create Coaching Observations');
            }
        }
    };

    const rowExpansionTemplate = (rowData: any) => {
        setSelectedEmploye(rowData);
        return (
            <div className="coaching-subgrid">
                <TriadExpandedGrid
                    selectedEmployee={rowData.employee_number}
                    inputYear={props?.inputYear}
                    inputMonth={props?.inputMonth}
                    handleGridButtonClick={handleGridButtonClick}
                    handlefollowupClick={handlefollowupClick}
                    isPseudoSupervisor={isPseudoSupervisor}
                    userManagerLevel={userManagerLevel}
                    loggedEmpNo={loggedEmpNum}
                />
            </div>
        );
    };

    const expandDescirption = (rowData: any, expandedRows: any) => {
        if (
            expandedRows &&
            expandedRows.some((expandedRow: any) => expandedRow.employee_number === rowData.employee_number)
        ) {
            return '';
        }
        if (rowData.direct_reportees_count > 0) {
            return <p>Expand to view your team</p>;
        } else {
            return '';
        }
    };
    const allowExpansion = (rowData: any) => {
        if (rowData.direct_reportees_count !== null && rowData.direct_reportees_count > 0) return true;
        else return false;
    };

    const renderIcons = (rowData: any, columnName: string) => {
        const isManager = ROLES.Supervisor2AndManagers.includes(userManagerLevel);
        const isSupervisor = ROLES.Supervisor.includes(userManagerLevel);
        const hasData = !!rowData[columnName]; // Check if the column has data        
        if (isSupervisor && ROLES.Agents.includes(rowData.manager_level) && rowData.total_created_count > 0) {
            return 'pi pi-pencil';
        }
        if (isManager || ROLES.DirectorOrAbove.includes(userManagerLevel)) {
            return hasData ? 'pi pi-pencil' : 'pi pi-plus';
        }

        if (isSupervisor && hasData) {
            return 'pi pi-pencil';
        }

        return false;
    };

    const buttonTemplate = (rowData: any, columnName: string, colorCode: any) => {
        const countValue = rowData?.tl_assoc_created_count;
        const color = colorCode;
        const icon = renderIcons(rowData, 'tl_assoc_created_count');
        const mode = icon === 'pi pi-plus' ? 'new' : 'edit';
        return (
            <div style={{ textAlign: 'center' }}>
                <div>
                    <Button
                        type="button"
                        icon={icon}
                        //disabled={props.inputMonth !== new Date().getMonth() + 1 && props.inputYear === new Date().getFullYear()}
                        // disabled={
                        //     rowData?.tl_assoc_created_count <= 0 //&& ROLES.DirectorOrAbove.includes(userManagerLevel)
                        // }
                        style={{
                            background: 'transparent',
                            border: `${color} 1px solid`,
                            color: `${color}`,
                            width: '30px',
                            height: '30px',
                            marginRight: '10px',
                        }}
                        onClick={() => {
                            handleGridButtonClick(columnName, 'parent', rowData, mode);
                        }}
                    />
                </div>
                <div style={{ background: `${colorCode}`, height: '2px', margin: '10px 0px' }}>&nbsp;</div>
                {rowData.direct_reportees_count !== null && rowData.direct_reportees_count !== 0 ? (
                    <div style={{ marginRight: '10px' }}>
                        {countValue}/{rowData.direct_reportees_count}
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    };

    const ackRender = () => {
        return <div style={{ textAlign: 'center' }}>Acknowledged / Created</div>;
    };

    const scoreRender = (rowData: any) => {
        return (
            <div style={{ textAlign: 'center' }}>
                Average:{' '}
                {rowData?.tl_avg_asse_score?.length > 0
                    ? (rowData?.tl_avg_asse_score * 100).toFixed(2) + '%'
                    : '--'}
            </div>
        );
    };

    const followUpRender = (rowData: any) => {
        if (
            ROLES.Supervisor.includes(rowData?.manager_level) &&
            (!ROLES.Supervisor.includes(userManagerLevel) || rowData?.follow_up_discussions_count > 0)
        ) {
            return (
                <div style={{ textAlign: 'center' }}>
                    {rowData?.follow_up_discussions_count > 0 ? (
                        <div style={{ textAlign: 'center', display: 'inline-block', marginLeft: '0px' }}>
                            <div
                                style={{
                                    border: '1px solid #00D6BB',
                                    padding: '5px 10px',
                                    borderRadius: '5px',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <span>{rowData?.follow_up_discussions_count}</span>
                                <div
                                    style={{
                                        height: '20px',
                                        width: '1px',
                                        backgroundColor: '#00D6BB',
                                        margin: '0 10px',
                                    }}
                                />
                                <i
                                    className="pi pi-eye"
                                    style={{ cursor: 'pointer', color: '#00D6BB' }}
                                    onClick={() => handlefollowupClick(rowData)}
                                />
                            </div>
                        </div>
                    ) : (
                        <Button
                            type="button"
                            icon={'pi pi-plus'}
                            style={{
                                background: 'transparent',
                                border: '#00D6BB 1px solid',
                                color: '#00D6BB',
                                width: '30px',
                                height: '30px',
                            }}
                            onClick={() => {
                                handlefollowupClick(rowData);
                            }}
                        />
                    )}
                </div>
            );
        } else {
            return <div style={{ textAlign: 'center' }}>--</div>;
        }
    };

    const handlefollowupClick = (rowData: any) => {
        const hasFollowUpDiscussions = rowData?.follow_up_discussions_count > 0;
        const isManager = ROLES.Manager.includes(userManagerLevel);
        if (hasFollowUpDiscussions || isManager) {
            setRecieverId(rowData?.employee_number);
            setReceiverName(rowData?.employee_name);
            setDisplayModal(true);
            setViewState(hasFollowUpDiscussions ? 'read' : 'new');
            setShowConversationModal(true);
            setShowTriadModal(false);
        } else {
            toast.warning('Only Managers can create Follow-up Discussions');
        }
    };

    const renderConversationLog = () => {
        if (viewState === 'read') {
            return (
                <ReadConversationLog
                    setViewState={setViewState}
                    setDisplayModal={setDisplayModal}
                    viewState={viewState}
                    displayModal={displayModal}
                    authorId={loggedEmpNum}
                    authorName={loggedEmpUser}
                    recieverId={recieverId}
                    inputYear={props?.inputYear}
                    inputMonth={props?.inputMonth}
                    receiverName={receiverName}
                    via={CoachingTabs.CoachingObservations}
                />
            );
        } else if (viewState === 'new') {
            return (
                <NewConversationLog
                    setViewState={setViewState}
                    setDisplayModal={setDisplayModal}
                    viewState={viewState}
                    displayModal={displayModal}
                    authorId={loggedEmpNum}
                    authorName={loggedEmpUser}
                    recieverId={recieverId}
                    receiverName={receiverName}
                    via={CoachingTabs.CoachingObservations}
                    date={props?.date}
                    coachingEntityId={0}
                    coachingEntityTypeId={CoachingEntityTypes.CoachingObservations}
                />
            );
        }
        return '';
    };

    const handleReset = () => {
        setSelectedTeam('');
        props?.setDate(new Date());
        localStorage.removeItem('searchedUser');
        localStorage.removeItem('selectedTeam');
        setCoachingSummaryList([]);
    };

    const DateOnChange = (e: any) => {
        if (!(e.value instanceof Date) || isNaN(e.value.getTime())) return;
        props?.setDate(e.value);
        props?.setMonth(e.value.getMonth() + 1);
        props?.setYear(e.value.getFullYear());
        saveSCfilDate(e.value);
    };

    const handleGuidance = () => {
        setIsCoachingGuidanceVisible(!isCoachingGuidanceVisible);
    };

    useEffect(() => {
        const searchedUserString: string | null = localStorage.getItem('searchedUser');
        if (selectedTeam === 'search' && !ROLES.DirectorOrAbove.includes(userManagerLevel)) {
            if (searchedUserString) {
                const searchedUser: SearchedEmployeType = JSON.parse(searchedUserString);
                setVisible(false);
                setSearchedEmployee(searchedUser);
            } else {
                setVisible(true);
            }
        }
    }, [selectedTeam])
    
    const renderTriadModal = () => {
        return (
            <TriadHome
                OnDisplayModal={setDisplayModal}
                displayModal={displayModal}
                hirearchy={hirearchy}
                month={props?.inputMonth}
                loggedEmp={loggedEmpNum}
                year={props?.inputYear}
                date={props?.date}
                // triadVersionId={triadVersionId}
                isConfiguredNewTriad={isConfiguredNewTriad}
                // childGridData={childGridData}
                loggedEmpNo={loggedEmpNum}
            />
        );
    };
    const renderTriadRecordModal = () => {
        return (
            <TriadHome
                OnDisplayModal={setDisplayModal}
                displayModal={displayModal}
                hirearchy={hirearchy}
                month={triadMonth}
                loggedEmp={triadReceipient}
                year={triadYear}
                date={props?.date}
                // triadVersionId={triadVersionId}
                isConfiguredNewTriad={isConfiguredNewTriad}
                // childGridData={childGridData}
                loggedEmpNo={loggedEmpNum}
            />
        );
    };

    return (
        <>
            {(ROLES.SupervisorORAgents.includes(userManagerLevel) ||
                ROLES.OnlyManager.includes(userManagerLevel)) && (
                    <RevgenFilter
                        date={props?.date}
                        selectTeamList={selectTeamList}
                        selectedTeam={selectedTeam}
                        userManagerLevel={userManagerLevel}
                        handleReset={handleReset}
                        DateOnChange={DateOnChange}
                        setSelectedTeam={setSelectedTeam}
                        setVisible={setVisible}
                        setSelectTeamList={setSelectTeamList}
                        parent="triads"
                    />
                )}
            {ROLES.DirectorOrAbove.includes(userManagerLevel) && (
                <div className="row">
                    <ManagerSelectionView
                        employeeName={loggedEmpUser}
                        selectedManager={setSelectedManager}
                        selectedDate={setSelectedDate}
                        userParentClient={props?.userParentClient}
                    />
                </div>
            )}
            <div className="d-flex justify-content-between mb-2">
                <p style={{ marginTop: '10px', marginLeft: '35%', marginBottom: '0px' }}>
                    Select a month and team above, click &quot; <i className="pi pi-plus" /> &quot; to add and
                    &quot; <i className="pi pi-pencil" /> &quot; to edit
                </p>
                <Button
                    label="What is a Coaching Observation?"
                    // style={{ padding: '6px' }}
                    icon="ConversationGuidelinesIcon"
                    onClick={() => setIsCoachingGuidanceVisible(true)}
                    className="btn-primary me-1 ms-2"
                />
            </div>
            <div className="row">
                <DataTable
                    value={coachingSummaryList}
                    id="coaching-observation"
                    rows={5}
                    paginator={coachingSummaryList?.length > 5}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    emptyMessage="No records found."
                    rowExpansionTemplate={rowExpansionTemplate}
                    expandedRows={expandedRows}
                    onRowToggle={(e) => {
                        setExpandedRows(e.data);
                    }}
                >
                    <Column field="employee_name" header={triadHeaderTeplate()} style={{ width: '10rem' }} />
                    <Column
                        header={headerTemplate('Created', '#00D6BB')}
                        field="triads"
                        style={{ width: '7rem' }}
                        body={(rowData: any) => buttonTemplate(rowData, 'triads', '#00D6BB')}
                    />
                    <Column
                        header={headerTemplate('TL Acknowledged', '#00B6B2')}
                        field="triads"
                        style={{ width: '7rem' }}
                        body={ackRender()}
                    />
                    <Column
                        header={headerTemplate('Scores', '#009C98')}
                        field="triads"
                        style={{ width: '7rem' }}
                        body={(rowData: any) => scoreRender(rowData)}
                    />
                    <Column
                        header={headerTemplate('Follow-up Discussions', '#035957')}
                        field="triads"
                        style={{ width: '6.5rem' }}
                        body={(rowData: any) => followUpRender(rowData)}
                    />
                    <Column
                        style={{ width: '5rem' }}
                        body={(data) => expandDescirption(data, expandedRows)}
                    />
                    <Column key="expand" expander={allowExpansion} style={{ width: '1rem' }} />
                </DataTable>
            </div>
            {visible && (
                <EmployeeSearchPopUp
                    visible={visible}
                    searchedEmployee={searchedEmployee}
                    setVisible={setVisible}
                    setSelectedTeam={setSelectedTeam}
                    setSearchedEmployee={setSearchedEmployee}
                />
            )}
            {showTriadModal && renderTriadModal()}
            {showTriadRecordModal && renderTriadRecordModal()}
            {showConversationModal && renderConversationLog()}
            {isCoachingGuidanceVisible && (
                <CoachingGuidance
                    isCoachingGuidanceVisible={isCoachingGuidanceVisible}
                    onHide={handleGuidance}
                />
            )}
        </>
    );
};
